<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Name</h3>
            <input type="text" v-model="formData.Name" @input="setSlug()"/>
            <!--
            <h3>Slug</h3>
            <input type="text" v-model="formData.Slug" @input="editSlug()"/>
            -->
            <div class="checkbox-input">
                <input type="checkbox" v-model="formData.Template" />
                <h3>Is Template</h3>
            </div>
            <h3>Start From Template</h3>
            <select v-model="formData.SheetJSON" @change="checkTemplate()">
                <option :value="null">No Template</option>
                <option v-for="(template, i) in templates" :key="i" :value="template.SheetJSON">{{ template.Name }}</option>
            </select>
            <div v-if="formData.CompanyScorecard">
                <h3>Year</h3>
                <select v-model="formData.Year">
                    <option v-for="(year, i) in years" :key="i" :value="year">{{ year }}</option>
                </select>
            </div>

            <input :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export default defineComponent({
    name: 'AddCompanySheet',
    props: [ ],
    components: {
        
    },
    data() {
        return {
            disableButton: false,
            formData: {
                Name: '',
                Slug: '',
                Template: false,
                SheetJSON: null as any,
                Year: null as any,
                CompanyScorecard: false,
            },
            templates: [] as any,
            years: [] as any
        }
    },
    async created() {
        this.formData.Year = new Date().getFullYear();
        let year = this.formData.Year;
        for(let i = 0; i < 6; i++) {
            this.years.push(year);
            year++;
        }

        await axios.get(`${this.$store.state.apiUrl}/api/companysheets?onlyTemplates=true`)
            .then(resp => {
                this.templates = resp.data;
            })
            .catch(e => {
                console.log(e);
            })
    },
    methods: {
        async submit() {
            if(!this.formData.Name || !this.formData.Slug) {
                return;
            }

            if(this.formData.CompanyScorecard && this.formData.Year) {
                try {
                    const sheetJSON = JSON.parse(this.formData.SheetJSON);
                    const months = [
                        'Jan',
                        'Feb',
                        'Mar',
                        'Apr',
                        'May',
                        'Jun',
                        'Jul',
                        'Aug',
                        'Sep',
                        'Oct',
                        'Nov',
                        'Dec'
                    ]

                    const d = new Date(),
                        year = d.getFullYear(),
                        mondays = [];

                    d.setDate(1);

                    // Get the first Monday in the month
                    while (d.getDay() !== 1) {
                        d.setDate(d.getDate() + 1);
                    }

                    // Get all the other Mondays in the month
                    while (mondays.length < 52) {
                        var pushDate = new Date(d.getTime());
                        mondays.push('(' + months[pushDate.getMonth()] + ' ' + pushDate.getDate() + ')');
                        d.setDate(d.getDate() + 7);
                    }

                    for(let i = 0; i < 52; i++) {
                        sheetJSON.rows[1][i+1].secondLine = mondays[i];
                    }

                    this.formData.SheetJSON = JSON.stringify(sheetJSON);
                } catch(e) {
                    console.log(e);
                    alert('There was an error');
                    return;
                }
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/companysheets`, this.formData)
                .then(resp => {
                    window.open('/company-sheet/' + this.formData.Slug, '_blank')
                    this.$emit('close');
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error')
                })

            this.disableButton = false;
        },
        setSlug() {
            this.formData.Slug = this.formData.Name.toLowerCase().replace(/[^a-zA-Z0-9- ]/g, '').replace(/ /g, '-') + '-' + uuidv4();
        },
        checkTemplate() {
            if(!this.formData.SheetJSON) {
                this.formData.CompanyScorecard = false;
                return;
            }
            const sheetJSON = JSON.parse(this.formData.SheetJSON);
            this.formData.CompanyScorecard = sheetJSON.companyScorecard;
        }
    }
});
</script>